import { render } from "./ConfigIcon.vue?vue&type=template&id=f446244a&scoped=true"
import script from "./ConfigIcon.vue?vue&type=script&lang=js"
export * from "./ConfigIcon.vue?vue&type=script&lang=js"

import "./ConfigIcon.vue?vue&type=style&index=0&id=f446244a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f446244a"]])

export default __exports__